exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tableTooltips__tooltip___HNxsY{display:block;padding-top:4px}.tableTooltips__icon___3PSoC{margin-bottom:4px;position:relative;display:inline-block}.tableTooltips__icon___3PSoC:hover{opacity:.7;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\"}.tableTooltips__tooltipBody___3OxNr{width:400px}", ""]);

// exports
exports.locals = {
	"tooltip": "tableTooltips__tooltip___HNxsY",
	"icon": "tableTooltips__icon___3PSoC",
	"tooltipBody": "tableTooltips__tooltipBody___3OxNr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/ExplorerTabContent/overrides/tableTooltips.pcss
// module id = 885
// module chunks = 0